import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import b from 'b_';
import FuseModalLayout from '../ConfirmationModal/FuseModalLayout';
import FuseButton from '../FuseControls/FuseButton';
import { FTBody } from '../Fuse';
import FuseReadOnlySelect from '../FuseControls/FuseReadOnlySelect';
import debug, { DEBUG } from '../../debug';
import FuseProgressIndicator, {
    PROGRESS_INDICATOR_SIZES,
    PROGRESS_INDICATOR_TYPES
} from '../FuseControls/FuseProgressIndicator';
import ReportDownloadStore from '../../stores/ReportDownloadStore';
import './FileDownloadModal.css';
import SnackStore from '../../stores/SnackStore';

const block = b.lock('FileDownloadModal');
const logger = debug.create('FileDownloadModal', DEBUG);
class FileDownloadModal extends Component {
    static propTypes = {
        store: ReportDownloadStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };
    static defaultProps = {
        hideLeftBtn: false,
    };

    componentDidCatch(error, info) {
        logger.error('componentDidCatch', error, info);
    }

    downloadReport = () => {
        const { store, snack } = this.props;
        store.downloadReport().catch(() => { snack.showError('Report download failed.'); });
    }

    render() {
        const {
            store,
        } = this.props;
        const leftBtnProps = {
            type: FuseButton.type.SECONDARY,
            color: FuseButton.color.BLUE,
            fullWidth: true,
            qa: 'cancel-modal-dwn',
            onClick: store.hideModal,
        };
        const rightBtnProps = {
            type: FuseButton.type.PRIMARY,
            color: FuseButton.color.BLUE,
            fullWidth: true,
            qa: 'generate-modal-dwn',
            disabled: store.reportDownloadStatus.isLoading || !store.datesRangeOptions?.selectedValues.length,
            onClick: this.downloadReport,
        };

        return <FuseModalLayout
            isOpen={store.isOpen.getValue()}
            title={'Isolation Executive Report'}
            leftBtnLabel="Cancel"
            rightBtnLabel={`${store.reportDownloadStatus.isLoading ? 'Generating' : 'Download'} Report`}
            leftBtnProps={leftBtnProps}
            rightBtnProps={rightBtnProps}
            hideLeftBtn={Boolean(false)}
        >
            {store.reportDownloadStatus.isLoading ? <div className={block('Spinner')}>
                <FuseProgressIndicator
                    type={PROGRESS_INDICATOR_TYPES.CIRCULAR}
                    size={PROGRESS_INDICATOR_SIZES.MEDIUM}
                />
            </div> : <FuseReadOnlySelect
                singleSelection
                store={store.datesRangeOptions}
                placeholderIcon="date_range"
                placeholder="Select a Date Range"
                selectLabel="Date Range"
                hint="Custom date ranges cannot exceed 90 days"
                qa="date-range-modal-dwn"
            /> }
            <FTBody style={{ marginTop: '20px' }}>
                Once the report is generated, your (PowerPoint .ppt) file will automatically download.
                This may take several minutes.
            </FTBody>
        </FuseModalLayout>;
    }
}
export default inject('snack')(observer(FileDownloadModal));
